import React, { useEffect, useState } from "react";
import Select from "react-select";
import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import { iconStyleOptions } from "../../Constants/brand";
import loadImage from "blueimp-load-image";
import "./index.css";

const MySwitch = withStyles({
  switchBase: {
    "&$checked": {
      color: "white",
    },
    "&$checked + $track": {
      backgroundColor: "darkgray",
    },
  },
})(Switch);
const BespokeColorItem = ({ type, onSave, isDark, isDisableSave }) => {
  const [isEditing, setEditing] = useState(false);
  const [hexValue, setHex] = useState("");
  useEffect(() => {
    setHex(type.default_value);
  }, [type]);
  const onChangeValue = ({ target }) => {
    setHex(target.value);
  };
  return (
    <div className="bespoke-item">
      <h4
        className="section-title"
        style={{ marginTop: 30, color: isDark ? "white" : "black" }}
      >
        {type.title}
      </h4>
      <div>
        <input
          type="text"
          name="hex"
          onChange={onChangeValue}
          style={{
            width: 180,
            height: 38,
          }}
          value={hexValue}
          disabled={isEditing ? "" : "disabled"}
        />
        {!isDisableSave && (
          <button
            className="btn"
            style={{
              backgroundColor: "darkgray",
              color: "white",
              marginLeft: 5,
            }}
            onClick={() => {
              if (isEditing) onSave(hexValue);
              setEditing(!isEditing);
            }}
          >
            {isEditing ? "Save" : "Edit"}
          </button>
        )}
      </div>
    </div>
  );
};
const PlatformChoose = ({ onSwitch, viewModes }) => {
  const [viewMode, setViewMode] = useState(viewModes[0]);
  const handleClick = (viewMode) => {
    onSwitch(viewMode);
    setViewMode(viewMode);
  };
  return (
    <div className="btn-group">
      {viewModes.map((item, index) => (
        <button
          key={index}
          className={`btn ${viewMode === item ? "active" : ""}`}
          onClick={() => handleClick(item)}
        >
          {item}
        </button>
      ))}
    </div>
  );
};
class BespokeBranding extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      brand_name: "",
      is_property_brand: false,
      dark: false,
      saveChanges: {},
    };
  }
  componentDidMount() {
    if (!this.props.location.state) this.props.history.push("/");
    else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
      Firebase.getBrandDataByID(brand, (res) => {
        if (res.white === true)
          this.setState({ icon_style: { value: "white", label: "White" } });
        else if (res.white === false)
          this.setState({ icon_style: { value: "black", label: "Black" } });
        if (res.dark) this.setState({ dark: true });
        else this.setState({ dark: false });
        this.setState({
          logo: res.logo,
          icon: res.icon,
          brand_name: res.name,
          brand_url: res.url,
          description: res.description,
          hex: res.hex,
          umbrella: res.umbrella,
          is_property_brand: res.is_property_brand
            ? res.is_property_brand
            : false,
          is_tasktool_need: res.is_tasktool_need,
        });
      });
    }
  }
  async componentDidUpdate() {
    const { brand, saveChanges } = this.state;
    if (Object.entries(saveChanges).length > 0) {
      await Firebase.updateBrandDataById(brand, saveChanges);
      this.setState({ saveChanges: {} });
    }
  }
  handleSelectIconChanged = (value) => {
    this.setState({ icon_style: value });
  };
  onEditIconStyle = async () => {
    const { edit_icon_style, icon_style, brand } = this.state;
    if (edit_icon_style === true) {
      let color = icon_style.value;
      const white = color === "white" ? true : false;
      await Firebase.updateBrandDataById(brand, { white: white });
    }
    this.setState({ edit_icon_style: !edit_icon_style });
  };
  saveColor = async (hex, field) => {
    const { brand } = this.state;
    let change = { [field]: hex };
    try {
      await Firebase.updateBrandDataById(brand, change);
    } catch (error) {
      console.log("error", error);
    }
  };
  onSwitchView = (viewMode) => {
    console.log("viewMode", viewMode);
  };
  handleChangeTheme = async ({ target }) => {
    const { brand } = this.state;
    this.setState({ dark: !this.state.dark });
    await Firebase.updateBrandDataById(brand, { dark: !this.state.dark });
  };
  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
    this.setState({
      saveChanges: {
        ...this.state.saveChanges,
        [name]: value,
      },
    });
  };
  onEditLogo = () => {
    const logo_ele = document.getElementById("logo_img");
    logo_ele.click();
  };
  onEditIcon = () => {
    const icon_ele = document.getElementById("icon_img");
    icon_ele.click();
  };
  // TODO: original method can be found in /Brand/index.js -> opportunity to refactor
  selectedFile = (e) => {
    const { brand, brand_name } = this.state;
    let _this = this;
    let id = e.target.id;
    if (e.target.files && e.target.files[0]) {
      var content = e.target.files[0];
      loadImage.parseMetaData(content, function (data) {
        //default image orientation
        var orientation = 0;
        if (data.exif) {
          orientation = data.exif.get("Orientation");
        }
        loadImage(
          content,
          function (canvas) {
            var base64data = canvas.toDataURL("image/png");
            var img_src = base64data.replace(/^data\:image\/\w+\;base64\,/, "");
            _this.setState({ [id]: img_src });
            if (id === "logo_img") {
              Firebase.updateLogoBrand(brand, brand_name, img_src);
            } else if (id === "icon_img") {
              Firebase.updateIconBrand(brand, brand_name, img_src);
            }
          },
          {
            canvas: true,
            orientation: orientation,
          }
        );
      });
    }
  };
  render() {
    const {
      username,
      role,
      logo,
      brand_name,
      brand,
      hex,
      is_property_brand,
      is_tasktool_need,
      icon_style,
      dark,
    } = this.state;

    return (
      <div
        id="page-container"
        style={{ backgroundColor: dark ? "black" : "unset" }}
      >
        <Header
          username={username}
          role={role}
          onHome={this.goBack}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          <div className="bespoke-content">
            {is_tasktool_need && (
              <PlatformChoose
                onSwitch={this.onSwitchView}
                viewModes={
                  is_property_brand
                    ? ["User", "Tasker", "Property"]
                    : ["User", "Tasker"]
                }
              />
            )}

            <div className="row">
              <BespokeColorItem
                type={{
                  title: "Brand main colour",
                  value: "brand_color",
                  default_value: hex || "#fafafa",
                }}
                isDark={dark}
                onSave={(hexValue) => this.saveColor(hexValue, "hex")}
              />
              <div className="iconstyle-item">
                <h4
                  className="section-title"
                  style={{ color: dark ? "white" : "black" }}
                >
                  Icon & text colour on brand
                </h4>
                <div className="group-input">
                  <div style={{ width: 200 }}>
                    <Select
                      isDisabled={!this.state.edit_icon_style}
                      value={icon_style}
                      onChange={this.handleSelectIconChanged}
                      options={iconStyleOptions}
                    />
                  </div>
                  <button
                    className="btn"
                    style={{
                      backgroundColor: "darkgray",
                      color: "white",
                      marginLeft: 5,
                    }}
                    onClick={this.onEditIconStyle}
                  >
                    {this.state.edit_icon_style ? "Save" : "Edit"}
                  </button>
                </div>
              </div>
              <div className="iconstyle-item">
                <h4
                  className="section-title"
                  style={{ color: dark ? "white" : "black" }}
                >
                  Member community colour mode
                </h4>
                <div className="group-input">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                    }}
                  >
                    <MySwitch
                      onChange={this.handleChangeTheme}
                      checked={dark}
                    />
                    <p style={{ color: dark ? "white" : "black" }}>
                      {dark ? "Dark mode" : "Light mode"}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <BespokeColorItem
                type={{
                  title: "Site background colour",
                  value: "brand_color",
                  default_value: dark ? "#000000" : "#ffffff",
                }}
                isDark={dark}
                isDisableSave={true}
              />
              <BespokeColorItem
                type={{
                  title: "Tab colour",
                  value: "tab_color",
                  default_value: dark ? "#000000" : "#ffffff",
                }}
                isDark={dark}
                isDisableSave={true}
              />
              <BespokeColorItem
                type={{
                  title: "Navigation header colour",
                  value: "brand_color",
                  default_value: dark ? "#000000" : "#ffffff",
                }}
                isDark={dark}
                isDisableSave={true}
              />
            </div>
            <div className="row row__branding">
              <h4
                className="section-title"
                style={{ marginTop: "30px", color: "black" }}
              >
                Brand description
              </h4>
              <input
                name="description"
                className="form-control form-control-md form-control-alt brand-registered-input"
                value={this.state.description}
                onChange={this.handleInputChange}
              />
            </div>
            <div className="row row__branding">
              <h4
                className="section-title"
                style={{ marginTop: "30px", color: "black" }}
              >
                Brand website URL
              </h4>
              <p>{this.state.brand_url}</p>
            </div>
            <div className="row row__branding">
              <h4
                className="section-title"
                style={{ marginTop: "30px", color: "black" }}
              >
                Logo
              </h4>
              <div className="logo-container" style={{ width: "716px" }}>
                <img src={this.state.logo} width="80%" alt="logo" />
                <button className="btn btn-success" onClick={this.onEditLogo}>
                  Edit
                </button>
              </div>
            </div>
            <div className="row row__branding">
              <h4
                className="section-title"
                style={{ marginTop: "30px", color: "black" }}
              >
                Icon
              </h4>
              <div className="logo-container">
                <img
                  src={this.state.icon}
                  width="80px"
                  height="80px"
                  alt="icon"
                  className="icon"
                />
                <button
                  className="btn btn-success mb-2"
                  onClick={this.onEditIcon}
                >
                  Edit
                </button>
              </div>
            </div>
            <input
              type="file"
              id="logo_img"
              name="logo-file-input"
              accept="image/*"
              style={{ display: "none" }}
              onChange={() => this.selectedFile}
            />
            <input
              type="file"
              id="icon_img"
              name="icon-file-input"
              accept="image/*"
              style={{ display: "none" }}
              onChange={this.selectedFile}
            />
          </div>
        </main>
      </div>
    );
  }
}

export default BespokeBranding;



// WEBPACK FOOTER //
// ./src/screens/BespokeBranding/index.js